import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const attendanceSlice = createSlice({
  name: "attendanceSlice",
  initialState: {
    term: [],
    className: [],
    classDate: [],
    attendance: [],
    attendanceReport: {},
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },
  reducers: {
    setTermData: (state, action) => {
      state.term = action.payload;
    },
    setClassNameData: (state, action) => {
      state.className = action.payload;
    },
    setClassDateData: (state, action) => {
      state.classDate = action.payload;
    },
    setAttendanceData: (state, action) => {
      state.attendance = action.payload;
    },
    setAttendanceReport: (state, action) => {
      state.attendanceReport = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
  },
});

const {
  setTermData,
  setClassNameData,
  setClassDateData,
  setAttendanceData,
  setErrorStatusCode,
  setErrorMessage,
  setDataFetchingStatus,
  setAttendanceReport,
} = attendanceSlice.actions;

export const getTerms =
  ({ applicantId, type }) =>
  (dispatch) => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    dispatch(setDataFetchingStatus(true));
    axios
      .get(
        `faculty/attendance/query?id=term&applicantId=${applicantId}&type=${type}`,
      )
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setTermData(response.data));
      })
      .catch((error) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };

export const getClasses = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .post(`faculty/attendance/query`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      if (data.query === "className") {
        dispatch(setClassNameData(response.data));
      } else if (data.query === "classDate") {
        dispatch(setClassDateData(response.data));
      } else if (data.query === "attendance") {
        dispatch(setAttendanceData(response.data));
      }
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const saveAttedance = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .post(`faculty/attendance`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getAttendaceReport = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .post(`faculty/attendancereport`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setAttendanceReport(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};

export default attendanceSlice.reducer;
